const Option = () => null;
Option.isSelectOption = true;
Option.displayName = 'OkkiAutoCompleteOption';
export default Option;
